import '.ax{position:relative;}.ssr-plugin'
import '.jc{width:64px;}.ssr-plugin'
import '.jd{height:64px;}.ssr-plugin'
import '.ar{flex-shrink:0;}.ssr-plugin'
import '.bs{position:absolute;}.ssr-plugin'
import '.je{bottom:-4px;}.ssr-plugin'
import '.hu{right:-4px;}.ssr-plugin'
import '.fh{border-radius:50%;}.ssr-plugin'
import '.jf{border:2px solid var(--palette-white);}.ssr-plugin'
import '.a8{overflow:hidden;}.ssr-plugin'
import '.jg{width:32px;}.ssr-plugin'
import '.jh{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="ax jc jd ar"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bs je hu fh jf a8 jg jh"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
